
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class SecurityMergeSourceDialog extends SiteEntityDialog<SecurityMergeSourceRow, any> {
        protected getFormKey() { return SecurityMergeSourceForm.formKey; }
        protected getIdProperty() { return SecurityMergeSourceRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityMergeSourceRow.localTextPrefix; }
        protected getNameProperty() { return SecurityMergeSourceRow.nameProperty; }
        protected getService() { return SecurityMergeSourceService.baseUrl; }

        protected form = new SecurityMergeSourceForm(this.idPrefix);

        protected getCloningEntity() {
            var clone = super.getCloningEntity();
            delete clone.SourceCode;
            return clone;
        }
    }
}